import {appConfig, i18n} from 'src/shared/config'

import qrSrc from '../assets/qr.gif'

export const legalLinks = [
  {
    label: 'Тарифы',
    href: '/tariffs/',
  },
  {
    label: 'Партнеры',
    href: 'https://taxi.yandex.ru/action/logistics/',
    rel: 'noreferrer',
    target: '_blank',
  },
  {
    label: 'Пользовательское соглашение',
    href: 'https://yandex.ru/legal/delivery_tou/',
    rel: 'noreferrer',
    target: '_blank',
  },
  {
    label: 'Как работают рекомендации',
    href: 'https://yandex.ru/legal/recommendations/#index__dostavka',
    rel: 'noreferrer',
    target: '_blank',
  },
  {
    label: 'Политика конфиденциальности',
    href: 'https://yandex.ru/legal/confidential/ru/',
    rel: 'noreferrer',
    target: '_blank',
  },
]

export const footerApp = {
  qr: qrSrc,
  buttons: {
    appStore:
      'https://8jxm.adj.st/route?tariffClass=express&ref=dostavka_web_badge&adj_t=ivdp40&adj_campaign=ALL-ALL-ALL&adj_adgroup=dostavka_web_badge&adj_deeplink=yandextaxi%3A%2F%2Froute%3FtariffClass%3Dexpress%26ref%3Ddostavka_web_badge',
    googlePlay: 'https://play.google.com/store/apps/details?id=ru.yandex.taxi',
    appGallery: 'https://appgallery.huawei.com/app/C101411413',
  },
}

export const footerLogo = {
  phrase1:
    appConfig.device === 'desktop'
      ? 'Доставка в приложении'
      : 'Доставка\nв приложении',
  phrase2: 'Наведите камеру на QR-код, чтобы скачать',
}

export const navLinks = [
  {
    label: i18n('order.footer.link.business', 'Бизнесу'),
    links: [
      {
        href: '/payment/',
        label: i18n('order.footer.link.become-a-client', 'Стать клиентом'),
      },
      {
        href: 'https://passport.yandex.ru/auth/list?retpath=https%3A%2F%2Fdostavka.yandex.ru%2Fauth&origin=b2b_dostavka',
        label: i18n(
          'order.footer.link.enter-to-personal-account',
          'Войти в личный кабинет',
        ),
      },
      {
        href: 'mailto:help@dostavka.yandex.ru',
        label: i18n(
          'order.footer.link.contact-support',
          'Написать в поддержку',
        ),
      },
      {
        href: '/about/',
        label: i18n('order.footer.link.business', 'О компании'),
      },
    ],
  },
  {
    label: i18n('order.footer.link.for-users', 'Пользователям'),
    links: [
      {
        href: '/tracking/',
        label: i18n('order.footer.link.track-parcel', 'Отследить посылку'),
      },
      {
        href: 'mailto:support.taxi@go.yandex.ru',
        label: i18n(
          'order.footer.link.contact-support',
          'Написать в поддержку',
        ),
      },
      {
        href: '/safety/',
        label: i18n(
          'order.footer.fraud-protection',
          'Как защититься от мошенников',
        ),
      },
      {
        href: '/insurance/',
        label: i18n(
          'order.footer.how-insurance-works',
          'Как работает страховка',
        ),
      },
    ],
  },
  {
    label: i18n('order.footer.for-courier', 'Курьерам'),
    links: [
      {
        href: '/for-courier/',
        label: i18n(
          'order.footer.become-driver-or-courier',
          'Стать пешим курьером или автокурьером',
        ),
      },
      {
        href: '/for-driver/personal-cargo/',
        label: i18n(
          'order.footer.become-a-cargo-driver',
          'Стать водителем грузовой машины',
        ),
      },
      {
        href: 'https://pro.yandex.ru/ru-ru/moskva/knowledge-base',
        rel: 'noreferrer',
        target: '_blank',
        label: i18n('order.footer.know-base', 'База знаний для курьеров'),
      },
    ],
  },
  {
    label: i18n('order.footer.carrier-at-delivery', 'Карьера в Доставке'),
    links: [
      {
        href: '/careers/',
        label: i18n('order.footer.about', 'Немного про Доставку'),
      },
      {
        href: '/careers/jobs/',
        label: i18n('order.footer.vacancies', 'Вакансии'),
      },
    ],
  },
  {
    label: i18n(
      'order.footer.delivery-at-your-city',
      'Доставка в вашем городе',
    ),
    links: [
      {
        href: '/region/',
        label: i18n(
          'order.footer.order-delivery-right-now',
          'Заказать доставку прямо сейчас',
        ),
      },
      {
        href: '/express-delivery/region/',
        label: i18n('order.footer.express-delivery', 'Экспресс-доставка'),
      },
      {
        href: '/courier/region/',
        label: i18n('order.footer.courier-delivery', 'Курьерская доставка'),
      },
      {
        href: '/cargo/region/',
        label: i18n('order.footer.cargo-delivery', 'Грузовая доставка'),
      },
      {
        href: '/next-day-delivery/region/',
        label: i18n(
          'order.footer.next-day-delivery',
          'Доставка на следующий день',
        ),
      },
      {
        href: '/24-hours/',
        label: i18n('order.footer.all-day-delivery', 'Круглосуточная доставка'),
      },
    ],
  },
]
